import styled from 'styled-components';

export const ContentWrapper = styled.div`
  padding: 1px 16px;
  
  /* This will target the Card component inside NutritionSettings to remove duplicate Card styling */
  & > div {
    box-shadow: none;
    border: none;
    padding: 0;
    
    /* Remove the title as we now have the table header */
    & > div:first-child {
      display: none;
    }
  }
`;
